import React, { ReactNode } from 'react';
import { fetchStoreSingular } from 'Util/_HumanWritten/FetchStoreSingular';
import Auth from 'Views/Components/Auth/Auth';
import useStore from 'Hooks/useStore';
import { useLocation } from 'react-router-dom';
import { BookingWizardData } from '../BookingWizardData/BaseBookingWizardData';
import { useBookingWizardDataStore } from '../BookingWizardDataStore';
import { VehicleBookingWizardData } from '../BookingWizardData/VehicleBookingWizardData';
import { assignDriverDetailsToPassenger } from '../BookingWizardData/PassengerDetail';

export interface AuthStepProps {
	children: ReactNode;
}

export function AuthStep({ children }: AuthStepProps) {
	const store = useStore();
	const location = useLocation();
	const { wizardData, setWizardData } = useBookingWizardDataStore();

	return (
		<Auth
			onAfterSuccess={() => {
				// If that is the value for userId, then it hasn't been set previously, which means that the user
				// wasn't logged in before they successfully authenticated
				if (wizardData.userId === '') {
					const store2 = fetchStoreSingular();
					if (!store.isStaff) {
						const newData = new BookingWizardData({ ...wizardData });
						// default value is only needed because of the typing. If auth was successful then the
						// userId will be set in the store
						newData.userId = store.userId ?? '';
						if (newData.innerWizardData instanceof VehicleBookingWizardData) {
							newData.innerWizardData.driverFirstName = store2.userData?.firstName ?? '';
							newData.innerWizardData.driverLastName = store2.userData?.lastName ?? '';
							newData.innerWizardData.driverPhone = store2.userData?.phone ?? '';
							assignDriverDetailsToPassenger(newData);
						}

						setWizardData(newData);
					}
				}
			}}
			redirectLocation={location.pathname}
		>
			{children}
		</Auth>
	);
}
